export const REQUEST_TYPES = {
  READY_FOR_COLLECTION: 'ready_for_collection',
  PRICE_REQUEST: 'only_price_request'
}
